import axios from 'axios';

const getStatements = (employmentStatus, combinedIssues, combinedTopics) => {
  const config = {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
  };

  const body = {
    employmentType: employmentStatus,
    issues: combinedIssues,
    topicsExcept: combinedTopics,
  };

  return axios.post(`${process.env.NEXT_PUBLIC_GRAPPLE_BACKEND_URL}filter-statement`, body, config);
};

export default getStatements;
